import styled from 'styled-components';

const TipoModeloCursosStyled = {
    Container: styled.div``,
};

export default TipoModeloCursosStyled;
